
import { Purchase } from "@/models/base";
import { PurchaseLedger } from "@/models/base/purchase-ledger";
import { printHumanFloat } from "@/utils/pretty-print";
import Vue from "vue";

export default Vue.extend({
	props: {
		purchase: {
			type: Object as ()=>Purchase,
			required: true
		},
		selectedItem: {
			type: Object as ()=>PurchaseLedger
		}
	},
	methods: {
		ledgerToText(ledger:PurchaseLedger):string{
			return `${ledger.LedgerCode} ${printHumanFloat(ledger.Amount)}`;
		},
		edit(ledger:PurchaseLedger){
			if (this.selectedItem == ledger) {
				this.$emit("selected-item", null);
			}else{
				this.$emit("selected-item", ledger);
			}
		},
		deleteItem(i:number){
			if (this.purchase.Ledgers[i] == this.selectedItem){
				this.$emit("set-new-empty-ledger");
			}
			this.purchase.Ledgers.splice(i,1);
		}
	}
});
